import { useTranslation } from 'react-i18next';
import { Box, Loader } from 'ui';

import { MobilePageHeader, ProcessDetails, WizardLayout } from '~/ui';

enum WizardTranslation {
  account = 'register',
  customer = 'createCustomerWizard',
  contract = 'createContractWizard',
  meteringPoint = 'createMeteringPointWizard',
}

export const WizardLoader = ({ currentWizard }: { currentWizard: string }) => {
  const { t } = useTranslation();

  const wizardTranslation = WizardTranslation[currentWizard as keyof typeof WizardTranslation];

  return (
    <WizardLayout
      leftChild={
        <ProcessDetails
          title={t(`${wizardTranslation}:title`)}
          subtitle={t(`${wizardTranslation}:subtitle`)}
          showBackButton={false}
        />
      }
      rightChild={
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <Loader />
        </Box>
      }
      header={<MobilePageHeader title={t(`${wizardTranslation}:title`)} showBackButton={false} />}
    />
  );
};
